export enum CustomerForm {
	DepositForm = 'DepositForm',
	LoanForm = 'LoanForm',
	TestForm = 'TestForm',
	SetPasswordIdCheckForm = 'SetPasswordIdCheckForm',
	ContactForm = 'ContactForm',
	CashToAccountForm = 'CashToAccountForm',
	CustomerInformationFormSDD = 'CustomerInformationFormSDD',
	OtpStartFormEs = 'OtpStartFormEs',
	OtpCompleteForm = 'OtpCompleteForm',
}
